import { motion } from "framer-motion";
import { GraduationCap, Award, Users, Globe } from "lucide-react";

export const EducationSection = ({ t }) => {
  return (
    <div className="font-mono">
      <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] mb-2">
        <span className="text-[#FF5722]">### </span>
        {t.education.heading}
      </h2>
      <p className="text-[11px] text-[var(--cm)] mb-10">{"// "}{t.education.overline.toLowerCase()}</p>

      <div className="grid lg:grid-cols-12 gap-px bg-[var(--border)]">
        <div className="lg:col-span-5 bg-[var(--surface)] p-6 md:p-8 space-y-8">
          <div data-testid="education-school">
            <GraduationCap size={20} className="text-[#FF5722] mb-3" />
            <div className="text-[12px] text-[var(--muted)]">
              <span className="text-[var(--fn)]">[{t.education.date}]</span>
            </div>
            <h3 className="mt-1 text-lg font-semibold text-[var(--text)]">{t.education.school}</h3>
            <p className="text-[13px] text-[var(--muted)]">{t.education.degree}</p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <Users size={14} className="text-[#FF5722]" />
              <h4 className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{t.education.communities.title}</h4>
            </div>
            <ul className="space-y-1.5">
              {t.education.communities.items.map((c) => (
                <li key={c} className="text-[12px] text-[var(--text-2)]">
                  <span className="text-[var(--muted)]">- </span>{c}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <Globe size={14} className="text-[#FF5722]" />
              <h4 className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{t.education.language.title}</h4>
            </div>
            <ul className="space-y-1.5">
              {t.education.language.items.map((l) => (
                <li key={l} className="text-[12px] text-[var(--text-2)]">
                  <span className="text-[var(--muted)]">- </span>{l}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-7 bg-[var(--surface)] p-6 md:p-8">
          <div className="flex items-center gap-2 mb-6">
            <Award size={14} className="text-[#FF5722]" />
            <h4 className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{t.education.certsHeading}</h4>
          </div>
          <div className="space-y-1">
            {t.education.certs.map((cert, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.04 }}
                data-testid={`cert-item-${i}`}
                className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 py-2 px-2 -mx-2 hover:bg-[var(--line-hover)] transition-colors group"
              >
                <span className="text-[11px] text-[var(--fn)]">[{cert.year}]</span>
                <span className="text-[13px] font-medium text-[var(--text)] group-hover:text-[#FF5722] transition-colors">
                  {cert.name}
                </span>
                <span className="text-[11px] text-[var(--cm)]">{"// "}{cert.org}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
